// api/cart.ts
import axios from 'axios';
import { apiUrl } from '../env';
import {
  CartPaymentIntentRequest,
  CartPaymentIntentResponse,
} from '../interfaces/payment';
import { getAuthHeaders } from './utils';

export const cartApi = {
  async createPaymentIntent(obj: CartPaymentIntentRequest) {
    const params = new URLSearchParams({
      total: obj.total.toString(),
      merchant_ids: obj.merchant_ids.join(','),
      platform_fee: obj.platform_fee.toString(),
      guest_id: obj.guest_id.toString(),
      description: obj.description,
      st_account_id: obj.st_account_id,
      currency: obj.currency,
      unique_time: obj.unique_time.toString(),
    });
    if (obj.region == 'europe-west2') {
      return axios.get<CartPaymentIntentResponse>(
        `${apiUrl}/api/v1/orders/new-model/checkout?${params}`,
        {
          headers: await getAuthHeaders(),
        },
      );
    } else {
      return axios.get<CartPaymentIntentResponse>(
        `${apiUrl}/api/v1/orders/new-model/checkout?${params}`,
        {
          headers: await getAuthHeaders(),
        },
      );
    }
  },
};
